import React from "react";
import { Link } from "react-router-dom";

function StoreItem(props) {
  const currency = (props.currency || 'usd').toUpperCase();
  const priceFormatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format((props.price || 0) / 100);
  
      return (
    <div >
      <h2>This is a cart item</h2>


<div className="card card-body blur shadow-blur mx-4 mx-md-5 mx-lg-10 mt-n9" style={{ paddingBottom: "60px" }}>

    <div className="section my-4 my-lg-5">
      <div className="container">
        <div className="row flex-row">
          <div className="col-lg-5">
            <img className="w-80 border-radius-lg ms-2" src={props.image} alt={props.name} loading="lazy" />
            <div className="my-gallery d-flex mt-4 pt-2">
              {props.images && props.images.slice(1).map((imgSrc, i) => (
                <figure key={i} className={i > 0 ? "ms-3" : ""}>
                  <a href={imgSrc} data-size="500x600">
                    <img className="w-100 min-height-100 max-height-100 border-radius-lg" src={imgSrc} alt={`${props.name} view ${i + 2}`} loading="lazy" />
                  </a>
                </figure>
              ))}
            </div>
          </div>
          <div className="col-lg-7">
            <div>
              <h3 className="mt-lg-0 mt-4">{props.name}</h3>
              <span className="badge badge-success">In Stock</span>
              <h6 className="mb-0 mt-2">Price</h6>
              <h5>{priceFormatted}</h5>
              <div className="accordion" id={`accordionProduct-${props.id}`}>
                <div className="accordion-item mb-1">
                  <h6 className="accordion-header" id={`headingOne-${props.id}`}>
                    <button className="accordion-button border-bottom font-weight-bold text-start" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne-${props.id}`} aria-expanded="true" aria-controls={`collapseOne-${props.id}`}>
                      Description
                      <i className="collapse-close fa fa-plus text-xs pt-1 position-absolute end-0"></i>
                      <i className="collapse-open fa fa-minus text-xs pt-1 position-absolute end-0"></i>
                    </button>
                  </h6>
                  <div id={`collapseOne-${props.id}`} className="accordion-collapse collapse show" aria-labelledby={`headingOne-${props.id}`} data-bs-parent={`#accordionProduct-${props.id}`}>
                    <div className="accordion-body text-sm opacity-8">
                      {props.description}
                    </div>
                  </div>
                </div>
                {props.metadata && props.metadata.designer_info && (
                <div className="accordion-item mb-1">
                  <h6 className="accordion-header" id={`headingTwo-${props.id}`}>
                    <button className="accordion-button border-bottom font-weight-bold text-start" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseTwo-${props.id}`} aria-expanded="false" aria-controls={`collapseTwo-${props.id}`}>
                      Designer Information
                      <i className="collapse-close fa fa-plus text-xs pt-1 position-absolute end-0"></i>
                      <i className="collapse-open fa fa-minus text-xs pt-1 position-absolute end-0"></i>
                    </button>
                  </h6>
                  <div id={`collapseTwo-${props.id}`} className="accordion-collapse collapse" aria-labelledby={`headingTwo-${props.id}`} data-bs-parent={`#accordionProduct-${props.id}`}>
                    <div className="accordion-body text-sm opacity-8">
                      {props.metadata.designer_info}
                    </div>
                  </div>
                </div>
                )}
                {props.metadata && props.metadata.care_instructions && (
                <div className="accordion-item mb-1">
                  <h6 className="accordion-header" id={`headingThree-${props.id}`}>
                    <button className="accordion-button border-bottom font-weight-bold text-start" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseThree-${props.id}`} aria-expanded="false" aria-controls={`collapseThree-${props.id}`}>
                      Details and Care
                      <i className="collapse-close fa fa-plus text-xs pt-1 position-absolute end-0"></i>
                      <i className="collapse-open fa fa-minus text-xs pt-1 position-absolute end-0"></i>
                    </button>
                  </h6>
                  <div id={`collapseThree-${props.id}`} className="accordion-collapse collapse" aria-labelledby={`headingThree-${props.id}`} data-bs-parent={`#accordionProduct-${props.id}`}>
                    <div className="accordion-body text-sm opacity-8">
                      <ul>
                        {props.metadata.care_instructions.split('|').map((item, i) => (
                          <li key={i}>{item.trim()}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                )}
              </div>
              <div className="row mt-5">
                {props.metadata && props.metadata.colors && (
                <div className="col-lg-6 mt-lg-0 mt-2">
                  <label className="ms-0">Select Color</label>
                  <select className="form-control" name="choices-material" id={`choices-material-${props.id}`}>
                    {props.metadata.colors.split(',').map((color, i) => (
                      <option key={i} value={color.trim()}>{color.trim()}</option>
                    ))}
                  </select>
                </div>
                )}
                {props.metadata && props.metadata.sizes && (
                <div className="col-lg-6 mt-lg-0 mt-2">
                  <label className="ms-0">Select Size</label>
                  <select className="form-control" name="choices-colors" id={`choices-colors-${props.id}`}>
                    {props.metadata.sizes.split(',').map((size, i) => (
                      <option key={i} value={size.trim()}>{size.trim()}</option>
                    ))}
                  </select>
                </div>
                )}
              </div>
              <div className="row mt-4">
                <div className="col-lg-4">
                  <Link
                    to={`/product/${props.id}`}
                    className="btn btn-outline-dark mb-0 w-100"
                  >
                    View Details
                  </Link>
                </div>
                <div className="col-lg-4 ms-auto">
                  <button className="btn bg-gradient-dark mb-0 mt-lg-auto w-100" type="button" onClick={() => props.onAddToCart({ id: props.id, priceId: props.priceId, name: props.name, price: props.price, image: props.image })}>Add to cart</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
   
<div> </div>
  

        </div>
      );
    }
    
    export default StoreItem;